module.exports = __webpack_public_path__ + "static/media/audit-icon.ad558fea.svg";